export default "__VITE_ASSET__B6w9vb0D__"